import axios from 'axios';
import API_BASE_URL from '../config.js';

const messageServices = async (data) => {

    const response = await axios.post(`${API_BASE_URL}/message/`, data
    );
    return response.data;

};

export default messageServices;
